export default "__VITE_ASSET__DGk06Tb___";